import { gql } from '@apollo/client';

const checkExistingShareObject = ({ datasetUri, input }) => {
    return {
        variables: {
            datasetUri: datasetUri,
            input: input,
        },
        query: gql`
            query checkExistingShareObject(
                $datasetUri: String!
                $input: NewShareObjectInput
            ) {
                checkExistingShareObject(
                    datasetUri: $datasetUri
                    input: $input
                ) {
                    shareUri
                    created
                    owner
                    status
                    approver
                    userRoleForShareObject
                    samlGroupName
                    #label
                    #deleted
                    #confirmed
                    #userInitiated
                    principal {
                        principalId
                        principalType
                        principalName
                        AwsAccountId
                        region
                        SamlGroupName
                        organizationName
                    }
                    items {
                        count
                        page
                        pages
                        hasNext
                        hasPrevious
                        nodes {
                            itemUri
                            shareItemUri
                            itemType
                            itemName
                            status
                            action
                            status
                            approver
                            owner
                        }
                    }
                    dataset {
                        datasetUri
                        datasetName
                        businessOwnerEmail
                    }
                }
            }
        `,
    };
};

export default checkExistingShareObject;
